import { AccountUrlConstant } from 'src/constants';
import {
  AccountDto,
  GetAccountDto,
  GetAccountListDto,
  GetAccountListResponseDto,
  LinkAccountDto,
  MoveAccountDto,
  ResetAccountAttemptsDto,
  SyncAccountDto,
  UnlinkAccountDto,
} from 'src/dtos';
import { ConfigService } from 'src/services';
import { httpRequest, replacePlaceholders } from 'src/utils';

export class AccountsApi {
  private _configService: ConfigService;
  constructor(configService: ConfigService) {
    this._configService = configService;
  }

  async retrieve({ params }: GetAccountDto): Promise<AccountDto> {
    const url = replacePlaceholders(AccountUrlConstant.RETRIEVE, params);

    return httpRequest<AccountDto>({
      method: 'GET',
      url,
      authToken: this._configService.authToken,
    });
  }

  async list({ queryParams }: GetAccountListDto): Promise<GetAccountListResponseDto> {
    return httpRequest<GetAccountListResponseDto>({
      method: 'GET',
      url: AccountUrlConstant.LIST,
      authToken: this._configService.authToken,
      queryParams,
    });
  }

  async downloadAgreement(id: string): Promise<Blob> {
    const url = replacePlaceholders(AccountUrlConstant.DOWNLOAD_AGREEMENT, { id });

    return httpRequest<Blob>({
      method: 'GET',
      url,
      authToken: this._configService.authToken,
      responseType: 'blob',
    });
  }

  async link({ params, body }: LinkAccountDto): Promise<AccountDto> {
    const url = replacePlaceholders(AccountUrlConstant.LINK, params);

    return httpRequest<AccountDto>({
      method: 'PUT',
      url,
      authToken: this._configService.authToken,
      body,
    });
  }

  async unlink({ params, body }: UnlinkAccountDto): Promise<AccountDto> {
    const url = replacePlaceholders(AccountUrlConstant.UNLINK, params);

    return httpRequest<AccountDto>({
      method: 'PUT',
      url,
      authToken: this._configService.authToken,
      body,
    });
  }

  async move({ params, body }: MoveAccountDto): Promise<AccountDto> {
    const url = replacePlaceholders(AccountUrlConstant.MOVE, params);

    return httpRequest<AccountDto>({
      method: 'PUT',
      url,
      authToken: this._configService.authToken,
      body,
    });
  }

  async sync({ params, body }: SyncAccountDto): Promise<AccountDto> {
    const url = replacePlaceholders(AccountUrlConstant.SYNC, params);

    return httpRequest<AccountDto>({
      method: 'PUT',
      url,
      authToken: this._configService.authToken,
      body,
    });
  }

  async syncStatusList(ids?: string[]): Promise<void> {
    return httpRequest<void>({
      method: 'PUT',
      url: AccountUrlConstant.SYNC_STATUS_LIST,
      authToken: this._configService.authToken,
      queryParams: { ids },
    });
  }

  async resetAttempts({ params, body }: ResetAccountAttemptsDto): Promise<AccountDto> {
    const url = replacePlaceholders(AccountUrlConstant.RESET_ATTEMPTS, params);

    return httpRequest<AccountDto>({
      method: 'PUT',
      url,
      authToken: this._configService.authToken,
      body,
    });
  }
}
